var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeOpacity: 0.5,
    strokeWidth: 3,
    d: "M895 36L903 44 911 36",
    transform: "translate(-894 -35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconDesktop);
export default __webpack_public_path__ + "static/media/expand-icon-desktop.210d667bd8b5d9f12022a2735f1e3325.svg";
export { ForwardRef as ReactComponent };